import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Palette, X } from 'lucide-react'

const themes = [
  'light', 'dark', 'cupcake', 'synthwave', 'retro', 'cyberpunk',
  'valentine', 'halloween', 'garden', 'forest', 'aqua', 'pastel',
  'fantasy', 'black', 'luxury', 'dracula', 'cmyk', 'autumn',
  'business', 'acid', 'lemonade', 'night', 'coffee', 'winter',
  'jarradtotman', 'neonpulse', 'cyberpunkcircuit', 'pipeworks',
]

const ThemeSwitcher = ({ currentTheme, onThemeChange }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-40 p-4 rounded-full bg-primary text-primary-content shadow-lg hover:shadow-xl transition-shadow"
        aria-label="Change theme"
      >
        <Palette className="w-6 h-6" />
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
              className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="fixed bottom-24 right-6 z-50 w-80 max-h-96 overflow-y-auto glass rounded-2xl shadow-2xl p-4"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold">Choose Theme</h3>
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-1 rounded-lg hover:bg-base-200"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="grid grid-cols-3 gap-2">
                {themes.map((theme) => (
                  <button
                    key={theme}
                    onClick={() => {
                      onThemeChange(theme)
                      setIsOpen(false)
                    }}
                    className={`p-3 rounded-lg text-sm font-medium transition-all ${
                      currentTheme === theme
                        ? 'ring-2 ring-primary bg-primary/20'
                        : 'hover:bg-base-200'
                    }`}
                    data-theme={theme}
                  >
                    <div className="w-full h-8 rounded mb-2 bg-primary"></div>
                    <span className="capitalize">{theme === 'pipeworks' ? 'Pipeworks' : theme}</span>
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}

export default ThemeSwitcher
